import { FormulaireCatalogue } from '@components/formulaire-catalogue/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const formulaireCatalogueMock: Block<FormulaireCatalogue> = {
  type: 'formulaire-catalogue',
  data: {
    image: imageMock,
    cta: {
      label: 'Consulter le catalogue',
      url: 'http://socooc.dev.com.localhost:4220/mock-catalogue/consultation',
    },
    title: {
      text: 'Téléchargez le catalogue',
      as: 'h2',
    },
    textOptin: "Je souhaite être informé des actualités et des offres SoCoo'c",
    text: `<p>Pour connaître l'utilisation que nous faisons des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en matière d'accès et de suppression, veuillez consultez notre <a href="/mock-confidentialite">charte de confidentialité</a></p>`,
    gtmConfigViewBtn: {
      event: 'click_cta_catalogue_voir',
      group: 'catalogue',
      description: 'page de catalogues',
      context: 'Consultation du catalogue',
    },
    gtmConfigDownloadBtn: {
      event: 'click_cta_catalogue_dl',
      group: 'catalogue',
      description: 'page de catalogues',
      context: 'Téléchargement du catalogue avec prise de coordonnées',
    },
  },
};
